import { css } from "@emotion/css";
import { appColors, fontWeight } from "../variables.style";

export const button = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${appColors.white};
  height: 64px;
  padding: 0 54px;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  color: ${appColors.white};
  background: linear-gradient(to bottom, ${appColors.orange500}, ${appColors.orange400});
  border: 1px solid transparent;
  border-radius: 10px;
  font-weight: ${fontWeight.semiBold};

  &:hover {
    color: ${appColors.white};
    background: linear-gradient(to top, ${appColors.orange500}, ${appColors.orange400});
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const buttonWhite = css`
  ${button}
  background: ${appColors.white};
  color: ${appColors.orange};

  &:hover {
    color: ${appColors.orange};
    background: ${appColors.gray200};
  }
`;
